export default __webpack_public_path__ + "static/media/coolerimage.b751dc28.png";